export default __webpack_public_path__ + "two-cards-section.png";